import React from "react";
import { makeStyles } from '@material-ui/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    height: "0",
    margin: "0 0 60px",
    padding: "25px 0 56.25%",
    position: "relative",
    overflow: "hidden",
    ['@media (max-width: 768px)']: {
      margin: "0 0 35px",
    }
  },
  iframe: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%"
  }
}));


const EmbedBlock = () => {
  const classes = blockStyles()

  return (
    <div className = { classes.root } >
      <iframe className = { classes.iframe }
              width="560"
              height="315" 
              src="https://www.youtube.com/embed/-SWht4RXOK0" 
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> 
      </iframe>
    </div>
  )  
}
export default EmbedBlock